export default __webpack_public_path__ + "static/developer-4ed4e66c8787d4bd0b0c80a809c453c6.svg";